<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="dialogFormVisible = true">增加赠品</el-button>
      <div class="box">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="input2">
        </el-input>
        <el-button type="primary">搜索</el-button>
      </div>
      
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="small">
        <el-table-column prop="sort" label="排序" width="140"></el-table-column>
        <el-table-column prop="title" label="进货时间" ></el-table-column>
        <el-table-column prop="title" label="产品名称" ></el-table-column>
        <el-table-column prop="title" label="产品库存" ></el-table-column>
        <el-table-column prop="title" label="操作时间" ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text">编辑</el-button>
            <el-button type="text" @click="deleteRow(scope.$index, scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!--  添加赠品 -->
    <el-dialog title="增加赠品" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="进货时间" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="赠品名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="库存" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [
        {
          imgUrl: "https://ae01.alicdn.com/kf/U632dc163d48d4d34a74088ca4c8e49b5W.png",
          sort: "1",
          name: "dsfsd电风扇",
          link: "",
          state: 1
        }
      ],
      form: {
        value: true,
        name: '',
        region: '',
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.getLocalData();
  },
  methods: {
    // 获取数据
    getLocalData() {
      this.tableData = JSON.parse(localStorage.getItem("sliceList"))
    },
    // 删除行
    deleteRow(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1)
      localStorage.setItem("sliceList", JSON.stringify(this.tableData));
    },
    addSlice() {
      this.$router.push({
        path: `adAdvertisement`
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    .box{
      width: 260px;
      display: flex;
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>